import { partnersCarouselImages } from './../../../../configs/brands';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { sport } from 'src/app/configs/sport';
import { features } from 'src/app/configs/featuresCarousel';
import { tarif } from 'src/app/configs/stripePlans';
import { mode } from 'src/app/configs/mode';
import { remark } from 'src/app/configs/usersComments';
import { OLD_SITE } from 'src/environments/environment.local';
import { OwlOptions, CarouselModule } from 'ngx-owl-carousel-o';
import { CountryService, LanguageService } from 'src/app/services';
import { Subscription } from 'rxjs';
import { FormatPricePipe } from '../../../../pipe/format-price.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { FaqComponent } from './faq/faq.component';
import { Carr2ImgComponent } from './carr2-img/carr2-img.component';
import { CarouselFeaturesComponent } from '../../../../shared/components/carousel-features/carousel-features.component';
import { HowToTrainComponent } from './how-to-train/how-to-train.component';
import { NgFor, NgIf, SlicePipe } from '@angular/common';
import { Step6Component } from '../home/components/step6/step6.component';
import { Store } from '@ngrx/store';
import { selectMeCurrency } from 'app/store/me/me.selectors';
import { CurrencyType } from 'app/services/gift-cards-plans.service';

@Component({
  selector: 'app-get-started',
  templateUrl: './get-started.component.html',
  styleUrls: ['./get-started.component.scss'],
  standalone: true,
  imports: [
    CarouselModule,
    NgFor,
    HowToTrainComponent,
    CarouselFeaturesComponent,
    Carr2ImgComponent,
    FaqComponent,
    SlicePipe,
    TranslateModule,
    FormatPricePipe,
    Step6Component,
  ],
})
export class GetStartedComponent implements OnInit, OnDestroy {
  private store: Store = inject(Store);

  dashboard = OLD_SITE;
  partnersImages = partnersCarouselImages;
  tabOfCarouselPartners = [];
  features = features;
  sport = sport;
  mode = mode;
  remark = remark;
  prices = tarif;
  currency: CurrencyType = 'eur';
  subscriptions: Subscription;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 300,
    autoplaySpeed: 300,
    autoplayTimeout: 3500,
    autoWidth: true,
    autoplay: true,
    responsive: {
      0: { items: 2 },
      400: { items: 3 },
      600: { items: 4 },
      800: { items: 5 },
      1000: { items: 6 },
      1200: { items: 7 },
      1700: { items: 8 },
    },
    nav: false,
  };

  constructor() {
    this.partnersImages.forEach((el) => {
      for (let index = 0; index < el.weight; index++) {
        this.tabOfCarouselPartners.push(el.name);
      }
    });
    this.tabOfCarouselPartners = this.spreadDistance(
      this.tabOfCarouselPartners
    );
  }

  ngOnInit(): void {
    this.subscriptions = this.store
      .select(selectMeCurrency)
      .subscribe((currency: CurrencyType) => {
        if (currency) {
          this.currency = currency;
        }
      });
  }

  spreadDistance(array) {
    let temp = [],
      count = {};

    for (let v of array) {
      if (!count[v]) count[v] = 0;
      if (!temp[count[v]]) temp[count[v]] = [];
      temp[count[v]].push(v);
      count[v]++;
    }
    return temp.flatMap((array) => array.sort((a, b) => count[b] - count[a]));
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
